import {
  Box,
  Typography,
  Container,
  Button,
  Grid,
  Card,
  CardContent,
  Link,
} from "@mui/material";
import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { useAnimation } from "../contexts/AnimationContext";
import PhoneIcon from "@mui/icons-material/Phone";

const accommodationsWSpecialRate = [
  {
    name: "Quinta Ribeira do Labrador",
    distance: "a 1 minuto da Quinta de D. Carlos",
    url: "https://www.ribeiradolabrador.pt",
    phoneDisplayNr: "+351 918 797 355",
    phoneNr: "+351918797355",
  },
  {
    name: "Gamboa's Place",
    distance: "a 6 minutos da Quinta de D. Carlos",
    url: "https://www.booking.com/hotel/pt/gamboas-place.pt-pt.html?aid=311098&label=gamboas-place-vECbN30xZD%2AWE25coIOxlAS589323753087%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-1511091233950%3Alp9220914%3Ali%3Adec%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YfpWGnRw6lOG-DQvPBEpJPI&sid=95c56983312357cd56f0aa1065374aa3&all_sr_blocks=724438804_310162671_0_1_0&checkin=2026-07-04&checkout=2026-07-05&dest_id=-2170897&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=724438804_310162671_0_1_0&hpos=1&matching_block_id=724438804_310162671_0_1_0&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&sr_pri_blocks=724438804_310162671_0_1_0__15120&srepoch=1766070780&srpvid=56b59b8b6c0ea137c73563fb4aca59c3&type=total&ucfs=1&",
    phoneDisplayNr: "+351 917 580 581",
    phoneNr: "+351917580581",
  },

  {
    name: "AL Embaixador",
    distance: "a 9 minutos da Quinta de D. Carlos",
    url: "https://www.booking.com/hotel/pt/al-embaixador.pt-pt.html?aid=1422243&label=mkt123sc-fdeaf7e3-e049-4a9c-9dcd-bc08d59653d1&sid=2e76834959ebb84fbb5e7ac089ad9fba&checkin=2026-07-04&checkout=2026-07-05&dest_id=1808563&dest_type=hotel&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&soh=1&sr_order=popularity&srepoch=1770684650&srpvid=6e7b05f2274c0367&type=total&ucfs=1",
    phoneDisplayNr: "+351 913 761 784",
    phoneNr: "+351913761784",
  },

  {
    name: "Alojamento das Fontes",
    distance: "a 10 minutos da Quinta de D. Carlos",
    url: "https://www.booking.com/hotel/pt/alojamento-das-fontes.pt-pt.html?aid=311098&label=hotel-97480-es-XcU2mmthXBY7O00bX4XaagS267092237921%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-412586236291%3Alp9061036%3Ali%3Adec%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YU5pXiVhsEsYvo03y-EPNDM&sid=3dfdbacdd2b152159c3979af816cf36d&all_sr_blocks=240056803_395117656_2_0_0&checkin=2026-07-04&checkout=2026-07-05&dist=0&group_adults=2&group_children=0&hapos=5&highlighted_blocks=240056803_395117656_2_0_0&hpos=5&matching_block_id=240056803_395117656_2_0_0&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=distance_from_search&sr_pri_blocks=240056803_395117656_2_0_0__7800&srepoch=1765301032&srpvid=385d7a086ca31823&type=total&ucfs=1&",
    phoneDisplayNr: "+351 934 092 059",
    phoneNr: "+351934092059",
  },

  {
    name: "Quinta da Pontinha",
    distance: "a 11 minutos da Quinta de D. Carlos",
    url: "https://www.booking.com/hotel/pt/quinta-da-pontinha.pt-pt.html?aid=311098&label=quinta-da-pontinha-CeINNGEVqmuXWTCJYKsDogS468134082438%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-793563393720%3Alp9220914%3Ali%3Adec%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YfpWGnRw6lOG-DQvPBEpJPI&sid=cb3a0d585d676e3f1c0bb231fad05f03&dest_id=-2157730&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&srepoch=1765283549&srpvid=42cc582b7dea00e1&type=total&ucfs=1&",
    phoneDisplayNr: "+351 968 410 548",
    phoneNr: "+351968410548",
  },
  {
    name: "Cas'Amaro Wine Villa",
    distance: "a 12 minutos da Quinta de D. Carlos",
    url: "https://www.booking.com/hotel/pt/cas-amaro.en-gb.html?aid=311984&label=cas-amaro-kOJbuNVA9HkOhEs_rxSwagS705950981036%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-2446728097117%3Alp9220914%3Ali%3Adec%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YXdX6HrtnYy-Ml68sH-ljtU&sid=cb3a0d585d676e3f1c0bb231fad05f03&dest_id=-2157730&dest_type=city&dist=0&group_adults=2&group_children=0&hapos=1&hpos=1&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=popularity&srepoch=1765283078&srpvid=427b573ed9de0002&type=total&ucfs=1&",
    phoneDisplayNr: "+351 964 600 943",
    phoneNr: "+351964600943",
  },
];

const accommodationsWithoutSpecialRate = [
  {
    name: "Quinta Correio Mor",
    distance: "a 6 minutos da Quinta de D. Carlos",
    url: "https://www.booking.com/hotel/pt/quinta-correio-mor.pt-pt.html?aid=311098&label=hotel-97480-es-XcU2mmthXBY7O00bX4XaagS267092237921%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-412586236291%3Alp9061036%3Ali%3Adec%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YU5pXiVhsEsYvo03y-EPNDM&sid=3dfdbacdd2b152159c3979af816cf36d&all_sr_blocks=1446710402_416055157_4_0_0&checkin=2026-07-04&checkout=2026-07-05&dist=0&group_adults=2&group_children=0&hapos=2&highlighted_blocks=1446710402_416055157_4_0_0&hpos=2&matching_block_id=1446710402_416055157_4_0_0&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=distance_from_search&sr_pri_blocks=1446710402_416055157_4_0_0__39755&srepoch=1765301022&srpvid=385d7a086ca31823&type=total&ucfs=1&",
  },
  {
    name: "Casinha da Encosta",
    distance: "a 9 minutos da Quinta de D. Carlos",
    url: "https://www.booking.com/hotel/pt/casinha-da-encosta-alenquer.pt-pt.html?aid=311098&label=hotel-97480-es-XcU2mmthXBY7O00bX4XaagS267092237921%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-412586236291%3Alp9061036%3Ali%3Adec%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YU5pXiVhsEsYvo03y-EPNDM&sid=3dfdbacdd2b152159c3979af816cf36d&all_sr_blocks=682507601_278233536_2_0_0&checkin=2026-07-04&checkout=2026-07-05&dist=0&group_adults=2&group_children=0&hapos=4&highlighted_blocks=682507601_278233536_2_0_0&hpos=4&matching_block_id=682507601_278233536_2_0_0&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=distance_from_search&sr_pri_blocks=682507601_278233536_2_0_0__11700&srepoch=1765301032&srpvid=385d7a086ca31823&type=total&ucfs=1&",
  },
  {
    name: "Cambeiros Guest House",
    distance: "a 13 minutos da Quinta de D. Carlos",
    url: "https://www.cambeirosguesthouse.com/",
  },
  {
    name: "Casa da Azinhaga",
    distance: "a 15 minutos da Quinta de D. Carlos",
    url: "https://www.booking.com/hotel/pt/casa-da-azinhaga-alenquer.pt-pt.html?aid=311098&label=hotel-97480-es-XcU2mmthXBY7O00bX4XaagS267092237921%3Apl%3Ata%3Ap1%3Ap2%3Aac%3Aap%3Aneg%3Afi%3Atikwd-412586236291%3Alp9061036%3Ali%3Adec%3Adm%3Appccp%3DUmFuZG9tSVYkc2RlIyh9YU5pXiVhsEsYvo03y-EPNDM&sid=3dfdbacdd2b152159c3979af816cf36d&all_sr_blocks=845752601_351584732_2_2_0&checkin=2026-07-04&checkout=2026-07-05&dist=0&group_adults=2&group_children=0&hapos=1&highlighted_blocks=845752601_351584732_2_2_0&hpos=1&matching_block_id=845752601_351584732_2_2_0&no_rooms=1&req_adults=2&req_children=0&room1=A%2CA&sb_price_type=total&sr_order=distance_from_search&sr_pri_blocks=845752601_351584732_2_2_0__9000&srepoch=1765300883&srpvid=385d7a086ca31823&type=total&ucfs=1&#map_closed",
  },
];

function Stay() {
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const gridRef = useRef(null);
  const textRef2 = useRef(null);
  const gridRef2 = useRef(null);

  const { animationStarted } = useAnimation();
  const titleInView = useInView(titleRef, { once: true, margin: "0px" });
  const textInView = useInView(textRef, { once: true, margin: "0px" });
  const gridInView = useInView(gridRef, { once: true, margin: "-50px" });
  const textInView2 = useInView(textRef2, { once: true, margin: "0px" });
  const gridInView2 = useInView(gridRef2, { once: true, margin: "-50px" });

  return (
    <>
      <Typography
        component={motion.h1}
        ref={titleRef}
        initial={{ opacity: 0, y: 40 }}
        animate={
          titleInView && animationStarted
            ? { opacity: 1, y: 0 }
            : { opacity: 0, y: 40 }
        }
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        variant="h1"
        sx={{
          fontFamily: '"Playfair Display", Georgia, serif',
          fontSize: { xs: "2.5rem", sm: "3.5rem" },
          fontWeight: 400,
          color: "#1a3a52",
          letterSpacing: "1px",
          mb: 6,
          textAlign: "center",
        }}
      >
        <Box component="span" sx={{ display: { xs: "inline", sm: "none" } }}>
          Alojamento <br />& Transporte
        </Box>
        <Box component="span" sx={{ display: { xs: "none", sm: "inline" } }}>
          Alojamento & Transporte
        </Box>
      </Typography>
      <Container maxWidth="md" sx={{ mt: 0, mb: 4 }}>
        <Box
          component={motion.div}
          ref={textRef}
          initial={{ opacity: 0, y: 30 }}
          animate={
            textInView && animationStarted
              ? { opacity: 1, y: 0 }
              : { opacity: 0, y: 30 }
          }
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          sx={{
            textAlign: "justify",
            px: { xs: 2, sm: 4, md: 6 },
            mb: 4,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1rem", sm: "1.1rem" },
              lineHeight: 2,
              color: "#2d4e66",
              mb: 2,
            }}
          >
            Para os que vêm de longe (ou de perto e querem aproveitar a noite ao
            máximo!), deixamos aqui algumas sugestões de alojamentos próximos à
            Quinta D. Carlos, com a respetiva distância de carro. Como julho é
            época alta de casamentos, recomendamos que reservem o alojamento com
            antecedência.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1rem", sm: "1.1rem" },
              lineHeight: 2,
              color: "#2d4e66",
              mb: 2,
            }}
          >
            Como gostaríamos de contar com a vossa presença, reservámos tarifas
            especiais em alguns alojamentos. Para beneficiarem do desconto, as
            reservas deverão ser feitas diretamente com o alojamento, através do
            contacto telefónico, e indicando que são nossos convidados.
          </Typography>
        </Box>
      </Container>

      <Box sx={{ px: { xs: 2, sm: 4, md: 6 }, mb: 6 }}>
        <Grid ref={gridRef} container spacing={3} justifyContent="center">
          {accommodationsWSpecialRate.map((accommodation, index) => (
            <Grid
              component={motion.div}
              initial={{ opacity: 0, y: 30 }}
              animate={
                gridInView && animationStarted
                  ? { opacity: 1, y: 0 }
                  : { opacity: 0, y: 30 }
              }
              transition={{
                duration: 0.6,
                delay: index * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
              item
              xs={12}
              sm={6}
              md={6}
              key={index}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                sx={{
                  width: { xs: "305px", md: "330px" },
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 2px 8px rgba(26,58,82,0.1)",
                  borderRadius: 2,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 4px 16px rgba(26,58,82,0.15)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <CardContent
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    p: 3,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: '"Open Sans", sans-serif',
                      fontSize: { xs: "1.2rem", sm: "1.3rem" },
                      fontWeight: 500,
                      color: "#1a3a52",
                      mb: 1,
                      mt: -1,
                    }}
                  >
                    {accommodation.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: '"Open Sans", sans-serif',
                      fontSize: { xs: "0.9rem", sm: "0.95rem" },
                      color: "#2d4e66",
                      mb: 2,
                      flexGrow: 1,
                    }}
                  >
                    {accommodation.distance}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 1,
                    }}
                  >
                    <Button
                      component="a"
                      href={`tel:${accommodation.phoneNr}`}
                      variant="outlined"
                      sx={{
                        borderColor: "#1a3a52",
                        color: "#1a3a52",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.3,
                        px: { xs: 1.5, sm: 2 },
                        py: 1,
                        minWidth: 0,
                        borderRadius: 1,
                        "&:hover": {
                          borderColor: "#2d4e66",
                          backgroundColor: "rgba(26, 58, 82, 0.04)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      <PhoneIcon
                        sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}
                      />
                      <Typography
                        sx={{
                          fontFamily: '"Open Sans", sans-serif',
                          fontSize: { xs: "0.75rem", sm: "0.85rem" },
                          fontWeight: 400,
                          textTransform: "none",
                        }}
                      >
                        {accommodation.phoneDisplayNr}
                      </Typography>
                    </Button>
                    <Button
                      component="a"
                      href={accommodation.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="contained"
                      sx={{
                        backgroundColor: "#1a3a52",
                        color: "#faf4e9",
                        fontFamily: '"Open Sans", sans-serif',
                        fontSize: { xs: "0.85rem", sm: "0.9rem" },
                        fontWeight: 500,
                        letterSpacing: "1px",
                        textTransform: "uppercase",
                        px: 3,
                        py: 1,
                        borderRadius: 1,
                        boxShadow: "0 2px 8px rgba(26,58,82,0.2)",
                        "&:hover": {
                          backgroundColor: "#2d4e66",
                          boxShadow: "0 4px 12px rgba(26,58,82,0.3)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      Ver
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Container maxWidth="md" sx={{ mt: 0, mb: 4 }}>
        <Box
          component={motion.div}
          ref={textRef2}
          initial={{ opacity: 0, y: 30 }}
          animate={
            textInView2 && animationStarted
              ? { opacity: 1, y: 0 }
              : { opacity: 0, y: 30 }
          }
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          sx={{
            textAlign: "justify",
            px: { xs: 2, sm: 4, md: 6 },
            mb: 4,
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: "1rem", sm: "1.1rem" },
              lineHeight: 2,
              color: "#2d4e66",
              mb: 2,
            }}
          >
            Para além das opções acima, existem outros alojamentos nas
            proximidades da Quinta D. Carlos. Estas opções não têm uma tarifa
            negociada, mas poderão ser uma boa alternativa.
          </Typography>
        </Box>
      </Container>
      <Box sx={{ px: { xs: 2, sm: 4, md: 6 }, mb: 6 }}>
        <Grid ref={gridRef2} container spacing={3} justifyContent="center">
          {accommodationsWithoutSpecialRate.map((accommodation, index) => (
            <Grid
              component={motion.div}
              initial={{ opacity: 0, y: 30 }}
              animate={
                gridInView2 && animationStarted
                  ? { opacity: 1, y: 0 }
                  : { opacity: 0, y: 30 }
              }
              transition={{
                duration: 0.6,
                delay: index * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
              item
              xs={12}
              sm={6}
              md={6}
              key={index}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Card
                sx={{
                  height: "160px",
                  width: { xs: "305px", md: "330px" },
                  display: "flex",
                  flexDirection: "column",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 2px 8px rgba(26,58,82,0.1)",
                  borderRadius: 2,
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 4px 16px rgba(26,58,82,0.15)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <CardContent
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    p: 3,
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: '"Open Sans", sans-serif',
                      fontSize: { xs: "1.2rem", sm: "1.3rem" },
                      fontWeight: 500,
                      color: "#1a3a52",
                      mb: 1,
                      mt: -1,
                    }}
                  >
                    {accommodation.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontFamily: '"Open Sans", sans-serif',
                      fontSize: { xs: "0.9rem", sm: "0.95rem" },
                      color: "#2d4e66",
                      mb: 2,
                      flexGrow: 1,
                    }}
                  >
                    {accommodation.distance}
                  </Typography>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      component="a"
                      href={accommodation.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      variant="contained"
                      sx={{
                        backgroundColor: "#1a3a52",
                        color: "#faf4e9",
                        fontFamily: '"Open Sans", sans-serif',
                        fontSize: { xs: "0.85rem", sm: "0.9rem" },
                        fontWeight: 500,
                        letterSpacing: "1px",
                        textTransform: "uppercase",
                        px: 3,
                        py: 1,
                        borderRadius: 1,
                        boxShadow: "0 2px 8px rgba(26,58,82,0.2)",
                        "&:hover": {
                          backgroundColor: "#2d4e66",
                          boxShadow: "0 4px 12px rgba(26,58,82,0.3)",
                        },
                        transition: "all 0.3s ease",
                      }}
                    >
                      Ver
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
    </>
  );
}

export default Stay;
